import { promiseImpl } from 'ejs';
import React, { useState } from 'react';
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import DocViewer,{ DocViewerRenderers } from "react-doc-viewer";
import{HomeProps} from './Home.tsx'
import CardEditor from "./CardEditor.tsx";
import { Intent, Classes ,H4} from "@blueprintjs/core";
import { Button, Card, Elevation,Slider, Overlay } from "@blueprintjs/core";
//import { Document, Page } from 'react-pdf/dist/esm/entry.parcel.js';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

import './cardpdf.css';
import './CardObject.css';
import {Toaster, Position} from "@blueprintjs/core";

const toaster=Toaster.create({
  className: "my-toaster",
  autoFocus:true,
  usePortal:false,
  position: Position.TOP_RIGHT
});

/*const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
};*/
export default class CardObject extends React.Component  <HomeProps> {
  state = {
    name: '',
    file:'',
    zoom:0.5,
    largeur:'620px',
    isOpenPdf:'none',
    numPages:0,
    force_width:'360px',
    force_height:480,
    isOpenEdit:false,
    title_document_creation:'',
    description_document_creation:'',
    objectif_document_creation:'',
    isOpenDelete:false,
    status_published:"eye-off",
    showcontenu:'block',
    elargir:'arrow-right',
    parent_height:480,
    url_data:'',
    ismsDocFile:false,
    sameorigin:false,
    viewer_url:'',
    docs:[]
  }  
 /* const docs = [
    { uri: "https://url-to-my-pdf.pdf" },
    { uri: require("./example-files/pdf.pdf") }, // Local File
  ];*/
  constructor(props) {
        super(props);
        //pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
        this.setState({file:props.url_video})
       // this.handleChange = this.handleChange.bind(this);
      }
  componentDidMount () { 
    this.setState({file:this.props.url_video})
    console.log(window.location.href);
    var url=this.props.url_video.split('/');
    console.log(url)
    var st=url[url.length-1];
    var obj={uri:window.location.href+'data/' +st};
    var st2=window.location.href+'data/' +st;
    this.setState({url_data:st2});
    this.setState({docs:[obj]});
    this.handleFileType(st2);
    this.setState({title_document_creation:this.props.title_document});
    this.setState({description_document_creation:this.props.description});
    this.setState({objectif_document_creation:this.props.objectif})
       
  }
 
  componentDidUpdate(prevProps, prevState) {
    
    if(prevProps.url_video!=this.state.file) {
      this.setState({file:prevProps.url_video});
      //var obj={uri:"https://placedesheros.com/data/1646035872.terraindemines.docx"};//this.props.url_video};
      console.log(window.location.href);
      var url=this.props.url_video.split('/');
      console.log(url)
      var st=url[url.length-1];
      var obj={uri:window.location.href+'data/' +st};
      var st2=window.location.href+'data/' +st;
      this.setState({url_data:st2});
      this.setState({docs:[obj]});
      this.handleFileType(st2);
    }
  }
  onFileChange=function (event) {
    this.setState({file:event.target.files[0]})
  }
  handle_published=()=>
  {
    console.log("handle_published");
    if(this.state.status_published=='eye-off'){
      this.setState({status_published:'eye-open'});
      toaster.show( {icon:'eye-open', intent:Intent.SUCCESS,timeout:2000,message:"Le document est disponible en ligne"});
    }else{
      this.setState({status_published:'eye-off'});
      toaster.show( {icon:'eye-off', intent:Intent.DANGER,timeout:2000,message:"Le document n'est plus disponible en ligne"});
    }
  }
   onDocumentLoadSuccess=function(ev) {
    console.log("onDocumentLoadSuccess");
    console.log(ev._pdfInfo.numPages);
    this.setState({numPages:ev._pdfInfo.numPages})
    this.setState({isOpenPdf:'none'});
    //setNumPages(nextNumPages);
  }
  renderLoader=function renderLoader(ev)
  {
    //console.log("ici");
    //console.log(ev);
    //console.log(this);
  }

  handleFileType(stfile){
    var st=stfile;
    var exts=st.split('.');
    console.log(exts);
    var ext=exts[exts.length-1];
    ext=ext.toLowerCase();
    this.setState({ismsDocFile:false});
    if(ext=="doc")this.setState({ismsDocFile:true});
    if(ext=="docx")this.setState({ismsDocFile:true});
    if(ext=="xls"){this.setState({ismsDocFile:true});this.setState({sameorigin:true});}
    if(ext=="xlsx"){this.setState({ismsDocFile:true});this.setState({sameorigin:true});}
    if(ext=="ppt"){this.setState({ismsDocFile:true});this.setState({sameorigin:true});}
    if(ext=="pptx"){this.setState({ismsDocFile:true});this.setState({sameorigin:true});}
    if(ext=="odt"){this.setState({ismsDocFile:true});this.setState({sameorigin:true});}
    if(ext=="odg"){this.setState({ismsDocFile:true});this.setState({sameorigin:true});}
    if(ext=="ods"){this.setState({ismsDocFile:true});this.setState({sameorigin:true});}
    if(ext=="txt")this.setState({ismsDocFile:true});

  }
  private getChangeHandler(key: string) {
    return (value: number) => this.setState({ [key]: value });
}
handletaille=()=>{
  this.setState({force_width:"100%"});
  this.setState({showcontenu:"block"});
  this.setState({elargir:"arrow-left"});
}
   render() {
    var htmlString="<iframe loading='lazy' style='width: 100%; height:"+ this.state.force_height+"px;border: 0'"
    if(this.state.sameorigin) htmlString+="src='https://view.officeapps.live.com/op/embed.aspx?src="+encodeURIComponent(this.state.url_data)+"' frameBorder='0' sandbox='allow-same-origin allow-scripts allow-forms'/>";
    else htmlString+="src='https://view.officeapps.live.com/op/embed.aspx?src="+encodeURIComponent(this.state.url_data)+"' frameBorder='0' sandbox='allow-scripts allow-forms'/>";
    //console.log(htmlString);
    
    const {youtube_frame,url_video,id_document,title_document,description,objectif,isnotdocument,navFiles,state,isnotconnected,menuVisibility,isOpenSign,usernickname,isOpenLogin,handleOpenVisio,handleOpen,handleClose,handleChange,handleSendCnx,handleSelectionChange,handleSelectionGetLogin,handleOpenLogin,handleCloseLogin,handleChangeLogin,handleSendCnxLogin}=this.props;

    return(
     <div draggable="true" style={{display:isnotdocument,width:this.state.force_width,margin:4,zIndex:1}}>
     
     <Card style={{width:this.state.force_width,margin:4,objectFit:'contain'}} interactive={true} elevation={Elevation.TWO}>
     <div style={{textAlign: 'right'}}>
     <Button onClick={(ev)=>{ev.preventDefault();this.setState({parent_height:"80px"});this.setState({showcontenu:"none"});}} className={Classes.OUTLINED } icon="minimize" title="Réduire" />
     <Button onClick={(ev)=>{ev.preventDefault();this.setState({parent_height:"480px"});this.setState({showcontenu:"block"});}} className={Classes.OUTLINED } icon="maximize" title="Augmenter" />
     <Button onClick={(ev)=>{
          ev.preventDefault();
          if(this.state.elargir=='arrow-right')
          {
            this.setState({force_width:"100%"});
            this.setState({showcontenu:"block"});
            this.setState({elargir:"arrow-left"});
            this.setState({isOpenPdf:'flex'});
            this.setState({isNotOpenPdf:'none'});
            this.setState({force_height:900})
          }
          else
          {
            this.setState({force_width:"360px"});
            this.setState({elargir:"arrow-right"});
            this.setState({isOpenPdf:'none'});
            this.setState({isNotOpenPdf:'flex'});
            this.setState({force_height:480})
          }
        }}
              
        className={Classes.OUTLINED } icon={this.state.elargir} title="Elargir" />
     </div>
     <h3><a href="">{title_document}</a></h3>
     <p><b>{description}</b></p>
     <p>{objectif}</p>
     {this.props.toolbar=='true'?<Button onClick={(ev)=>{ev.preventDefault();this.setState({isOpenEdit:true});}} className={Classes.OUTLINED +" "+ Classes.LARGE} icon="edit" title="Editer" />:<div></div>}
     {this.props.toolbar=='true'?<Button onClick={(ev)=>{ev.preventDefault();this.setState({isOpenDelete:true});}} className={Classes.OUTLINED+" "+ Classes.INTENT_DANGER +" " + Classes.LARGE} icon="trash" title="Effacer" />:<div></div>}
     {this.props.toolbar=='true'?<Button className={Classes.OUTLINED+" "+ Classes.LARGE +" "+ Classes.INTENT_WARNING} icon={this.state.status_published} title="Cours en ligne" onClick={(ev)=>{ev.preventDefault();this.handle_published();}}/>:<div></div>}
     {this.props.toolbar!='true'?<CardEditor _onUploadtext={this.props._onUploadtext} fromChildren={this.props.fromChildren} matiere_id={this.props.matiere_id} handletaille={this.handletaille} userid={this.props.userid} recordingsbydate={this.props.recordingsbydate} id_document={this.props.id_document} title_document={title_document}/>:null}
     <Overlay isOpen={this.state.isOpenDelete} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.props} {...this.state}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
                        <H4>Effacer le document {this.props.title_document}</H4>
                       
                        <p style={{marginTop:20}}>
                           Etes-vous sûr de vouloir effacer le document {this.props.title_document} ?
                        </p>
                                              
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({isOpenDelete:false});}}>Annuler</Button>
                            <Button intent={Intent.DANGER} onClick={(ev)=>{
                              ev.preventDefault();this.setState({isOpenDelete:false});
                              
                              var xhr = new XMLHttpRequest();
                              xhr.overrideMimeType("application/json");
                              var that=this;
                              xhr.open('GET','/api/public/deldocument?id_document='+this.props.id_document)
                              this.setState({file:''})
                              xhr.setRequestHeader("Content-Type", "application/json");

                              //send the form data
                              xhr.send();

                                    xhr.onreadystatechange = function() {
                                        if (xhr.readyState == XMLHttpRequest.DONE) {
                                                      
                                        if(xhr.status==200) 
                                        { 
                                        
                                          console.log(xhr.responseText);
                                          //that.props.onchildrenevent();
                                          that.props.LoadDataDocumentsDirect(-1)
                                          return;
                                          var jsonResponse = JSON.parse(xhr.responseText);
                                          console.log(jsonResponse);
                                          
                                          
                                          
                                        }
                                        if(xhr.status==404) {console.log( {message:"erreur"}); }
                                        if(xhr.status==500) {console.log( {message:"erreur"}); }
                                        
                                        }
                                      
                                    }
                              
                              
                              
                              
                              }} style={{ margin: "" }}>
                                Valider
                            </Button>
                            
                            
                        </div>
                    </div>
     </Overlay>
        
       {/* <Button style={{margin:'5px 0 5px 60px'}} onClick={(ev)=>{ev.preventDefault();if(this.state.zoom==0.5){this.setState({isOpenPdf:'flex'});this.setState({zoom:1.5});} else {this.setState({zoom:0.5});this.setState({isOpenPdf:'none'});}}}>{this.state.zoom==0.5 ? "Ouvrir" : "Fermer" }</Button>*
        <Slider
                    min={0.2}
                    max={3}
                    stepSize={0.1}
                    labelStepSize={10}
                    onChange={this.getChangeHandler("zoom")}
                    value={this.state.zoom}
                    vertical={false}
                />*/}
      <div style={{display:this.state.showcontenu}}>
          <p style={{fontSize:14, marginTop:'4px'}} ><a href={this.state.file} target="_blank">   <b>Télécharger</b></a>
          {this.state.ismsDocFile?<a style={{marginLeft:130}} href={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(this.state.url_data)}`} target="_blank">   <b>Voir en ligne</b></a>:null}
          </p>
          { !this.state.ismsDocFile ?<img style={{objectFit: 'scale-down', width: '10%', height: '10%'}} src="doc.png"></img>:
          <div style={{width:'100%'}}>
          <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
          {/*<iframe style={{width: '100%', height: this.state.force_height,border: '0'}}
            id="msdoc-iframe"
            title="msdoc-iframe"
            src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
              this.state.url_data
            )}`}
            frameBorder="0"/>*/}
        </div>
        }
        </div>
    </Card>
    <Overlay isOpen={this.state.isOpenEdit} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.props} {...this.state}>
      
      <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
      
        <H4>Edition d'un document</H4>
        <div style={{marginTop:5}}><span>Titre</span><input onChange={(ev)=>{this.props.handleEdition({id:this.props.id,title:ev.target.value,description:this.state.description_document_creation,objectif:this.state.objectif_document_creation});this.setState({title_document_creation:ev.target.value})}} value={this.state.title_document_creation} style={{padding:4,width:'100%'}} type="text" placeholder="Saisir le titre de votre document"/></div>
        <div style={{marginTop:5}}><span>Description</span><input onChange={(ev)=>{this.props.handleEdition({id:this.props.id,title:this.state.title_document_creation,description:ev.target.value,objectif:this.state.objectif_document_creation});this.setState({description_document_creation:ev.target.value})}} value={this.state.description_document_creation} style={{padding:4,width:'100%'}} type="text" placeholder="Saisir une description votre document"/></div>
        <div style={{marginTop:5}}><span>Objectif</span><input onChange={(ev)=>{this.props.handleEdition({id:this.props.id,title:this.state.title_document_creation,description:this.state.description_document_creation,objectif:ev.target.value});this.setState({objectif_document_creation:ev.target.value})}} value={this.state.objectif_document_creation} style={{padding:4,width:'100%'}} type="text" placeholder="Saisir un objectif ou une consigne"/></div>
        <div style={{marginTop:10}}>
          <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({isOpenEdit:false});}}>Annuler</Button>
          <Button style={{marginLeft:5}} intent={Intent.SUCCESS} onClick={(ev)=>{ev.preventDefault();this.props.handleEdition({id:this.props.id,title:this.state.title_document_creation,description:this.state.description_document_creation,objectif:this.state.objectif_document_creation,update:true});this.setState({isOpenEdit:false});}}>Valider la modification</Button>
        </div>
      </div>
      </Overlay>
    
     </div>);
}
}

